var orders = {
	selectors: { },

	init: function () {
		var self = this;

       self.declineOrder();
       self.acceptOrder();

       self.checkEmail();
	},

    checkEmailCall: function(email) {

        console.log("asdasd");
        let formData = new FormData();
        formData.append('action', 'check_email_domain');
        formData.append('email', email);
        formData.append('nonce', sikmoVars.nonce);

        fetch(sikmoVars.ajax_url, {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            console.log(data);
            if(data.data == 'free'){
                console.log('free');
                document.querySelectorAll('.choose-product__price').forEach(element => {
                    
                    element.textContent = '0';
                });
            } else {
                console.log('not free');
                document.querySelectorAll('.choose-product__price').forEach(element => {
                    const originalPrice = element.getAttribute('data-original-price');
                    if (originalPrice !== null) {
                      element.textContent = originalPrice;
                    }
                });
            }
            const checkedRadio = document.querySelector('input[name="variant"]:checked');
            if (checkedRadio) {
              checkedRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
        })
        .catch(error => console.error('Error:', error));
    },

    checkEmail: function() {
        let self = this;

        if(  document.querySelectorAll('.choose-product__price').length ) {
            document.querySelectorAll('.choose-product__price').forEach(element => {
                element.setAttribute('data-original-price', element.textContent);
            });
        }

        let email_input = document.querySelector( '[data-wpcf7-id="281"] input[name="email"]' );
        if( email_input ) {
            email_input.addEventListener('input', function(e) {
                let email = e.target.value;

                self.checkEmailCall(email);
            });

            self.checkEmailCall(email_input.value);
        }  

        
    },

    acceptOrder: function() {
        const acceptOrderButtons = document.querySelectorAll('.js-acceptOrder');

		let self = this;

        if( !acceptOrderButtons.length ) {  return; }

        acceptOrderButtons.forEach( button  => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
            
                let formData = new FormData();
                formData.append( 'action', 'accept_order' );
                formData.append( 'nonce', sikmoVars.nonce );
                formData.append( 'event_id', button.dataset.event_id ); 
                formData.append( 'order_id', button.dataset.order_id );

                fetch( sikmoVars.ajax_url, {
                    method: 'POST',
                    credentials: 'same-origin', 
                    body: formData
                })
                .then( response => response.json() )
                .then( data => {
                    button.closest('.card').remove();

                    const countOrdersElement = document.querySelector('.js-countOrders');
                    if (countOrdersElement) {
                        let currentCount = parseInt(countOrdersElement.textContent, 10);

                        if (!isNaN(currentCount)) {
                            currentCount -= 1;
                            countOrdersElement.textContent = currentCount;
                        }
                    }
                })
                .catch( error => console.error('Error:', error)) ;
            
            });
        });
	},

    declineOrder: function() {
        const declineOrderButtons = document.querySelectorAll('.js-declineOrder');

		let self = this;

        if( !declineOrderButtons.length ) {  return; }

        declineOrderButtons.forEach( button  => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
            
                let formData = new FormData();
                formData.append( 'action', 'decline_order' );
                formData.append( 'nonce', sikmoVars.nonce );
                formData.append( 'event_id', button.dataset.event_id );
                formData.append( 'order_id', button.dataset.order_id );

                fetch( sikmoVars.ajax_url, {
                    method: 'POST',
                    credentials: 'same-origin', 
                    body: formData
                })
                .then( response => response.json() )
                .then( data => {
                   button.closest('.card').remove();

                   const countOrdersElement = document.querySelector('.js-countOrders');
                    if (countOrdersElement) {
                        let currentCount = parseInt(countOrdersElement.textContent, 10);

                        if (!isNaN(currentCount)) {
                            currentCount -= 1;
                            countOrdersElement.textContent = currentCount;
                        }
                    }
                })
                .catch( error => console.error('Error:', error)) ;
            });
        });
	},
};

export { orders };


